import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_160: DocMigration = {
  maxSchemaVersion: "0.0.160",
  description: "Keeping eave return fascia top trim for old roofs",
  apply(json: any) {
    const { roofs } = json;

    // roof instances
    for (const roofId in roofs) {
      const roof = roofs[roofId];
      const { roofSettings = {} } = roof;

      roofSettings.includeEaveReturnFasciaTopTrim = roofSettings.eaveType === "BOXED_MINI_HIP";

      roofs[roofId] = {
        ...roof,
        roofSettings,
      };
    }

    return json;
  },
};

export default migration_0_0_160;
